// React Query queryKey SSOT for in-app notifications.
// ユーザーIDをキーに含める: ログアウト直後に別ユーザーがログインした場合に
// キャッシュされた通知が漏れないようにする（useIsAdmin と同じ理由）。

export const notificationQueryKeys = {
  all: ['notifications'] as const,
  unreadCount: (userId: string) =>
    ['notifications', userId, 'unreadCount'] as const,
  list: (userId: string) => ['notifications', userId, 'list'] as const,
  /**
   * 通知メールプレビュー。イベント単位＋切り替え条件でキャッシュする
   * （ユーザーIDは不要: 主催者・共同編集者しか取得できない）
   */
  preview: (
    eventId: string,
    notificationType: string,
    offset?: string,
    audience?: string,
  ) =>
    [
      'notifications',
      'preview',
      eventId,
      notificationType,
      offset ?? null,
      audience ?? null,
    ] as const,
} as const;
